import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StorageService } from '../../../services/storage.service';
import { forkJoin, Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ServiceApi } from '../../../apis/service/service.api';
import { RehabilitationApi } from '../../../apis/rehabilitation/rehabilitation.api';
import { EducationApi } from '../../../apis/education/education.api';
import { RehabilitationProgramDTO } from '../../../apis/rehabilitation/rehabilitation.dto';
import { EducationProgramDTO } from '../../../apis/education/education.dto';
import { ServiceDTO } from '../../../apis/service/service.dto';

@Component({
  selector: 'app-header-basket',
  imports: [RouterModule],
  standalone: true,
  templateUrl: './basket.component.html',
  styleUrl: './basket.component.scss',
})
@UntilDestroy()
export class HeaderBasketComponent {
  public counter: number = 0;

  constructor(
    private readonly storageService: StorageService,
    private readonly rehabilitationApi: RehabilitationApi,
    private readonly educationApi: EducationApi,
    private readonly serviceApi: ServiceApi
  ) {}

  ngOnInit(): void {
    this.observePrograms();
    this.storageService.chosenPrograms$
      .pipe(untilDestroyed(this))
      .subscribe((choosen) => {
        this.counter =
          (choosen.rehabilitation?.length || 0) +
          (choosen.education?.length || 0) +
          (choosen.service?.length || 0);
      });
  }

  private buildObservables(): {
    [key: string]: Observable<
      RehabilitationProgramDTO[] | EducationProgramDTO[] | ServiceDTO[]
    >;
  } {
    const obsObj: {
      [key: string]: Observable<
        RehabilitationProgramDTO[] | EducationProgramDTO[] | ServiceDTO[]
      >;
    } = {};

    const rehabilitationIds =
      this.storageService.getChosenPrograms().rehabilitation;
    if (rehabilitationIds) {
      obsObj['rehabilitation'] =
        this.rehabilitationApi.getByIds(rehabilitationIds);
    }

    const educationIds = this.storageService.getChosenPrograms().education;
    if (educationIds) {
      obsObj['education'] = this.educationApi.getByIds(educationIds);
    }

    const serviceIds = this.storageService.getChosenPrograms().service;
    if (serviceIds) {
      obsObj['service'] = this.serviceApi.getByIds(serviceIds);
    }

    return obsObj;
  }

  private observePrograms(): void {
    let obsObj = this.buildObservables();
    const hasObservables = Object.keys(obsObj).length > 0;
    if (hasObservables)
      forkJoin(obsObj)
        .pipe(untilDestroyed(this))
        .subscribe(
          (
            response: {
              rehabilitation?: RehabilitationProgramDTO[];
              education?: EducationProgramDTO[];
              service?: ServiceDTO[];
            } | null
          ) => {
            if (response) {
              this.storageService.chosenPrograms$.next({
                rehabilitation: response.rehabilitation || [],
                education: response.education || [],
                service: response.service || [],
              });
            }
          }
        );
  }
}
